// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Main Overview Container (Dark NOC Theme) ── */
.overview-container {
    padding: 24px;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    background-color: #0b0f19;
    min-height: 100vh;
    color: #f8fafc;
}

/* ── Distinct Styling for H2 and H3 Headings ── */
.overview-container h2.title {
    font-size: 28px;
    font-weight: 800;
    color: #ffffff;
    margin-bottom: 4px;
    letter-spacing: 0.5px;
    text-align: left;
    border-bottom: none;
    padding-bottom: 0;
}

.overview-container h3.title {
    font-size: 16px;
    font-weight: 600;
    color: #58a6ff;
    margin-top: 0;
    margin-bottom: 24px;
    text-align: left;
    text-transform: uppercase;
    letter-spacing: 1.5px;
    border-bottom: 1px solid #1f2937;
    padding-bottom: 12px;
}

/* ── Filter Cards Grid (Top Summary) ── */
.filter-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
    gap: 15px;
    margin-bottom: 30px;
}

.filter-box {
    background-color: #161b22;
    padding: 18px;
    border-radius: 12px;
    text-align: left;
    cursor: pointer;
    border: 1px solid #30363d;
    transition: all 0.25s ease;
    color: #c9d1d9;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    position: relative;
    overflow: hidden;
}

.filter-box:hover {
    transform: translateY(-3px);
    border-color: #58a6ff;
    background-color: #1c2128;
}

.filter-box.selected {
    border-color: #58a6ff;
    background-color: #1f2937;
    box-shadow: 0 0 15px rgba(88, 166, 255, 0.2);
}

/* Status / Category Accent Borders for Filters */
.filter-box.totalDevices { border-left: 5px solid #17a2b8; }
.filter-box.onlineDevices { border-left: 5px solid #238636; }
.filter-box.offlineDevices { border-left: 5px solid #da3633; }
.filter-box.switch { border-left: 5px solid #00bcd4; }
.filter-box.router { border-left: 5px solid #8bc34a; }
.filter-box.olt { border-left: 5px solid #fd7e14; }

.filter-label {
    font-weight: 600;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #8b949e;
    margin-bottom: 8px;
}

.filter-count {
    font-size: 28px;
    color: #ffffff;
    font-weight: 700;
}

/* ── Device Section & Grid ── */
.device-section {
    margin-top: 30px;
    animation: fadeIn 0.3s ease-in-out;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
}

.device-heading {
    font-size: 20px;
    margin-bottom: 20px;
    color: #e6edf3;
    font-weight: 600;
}

.device-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 18px;
}

/* ── Modern PingMon Style Device Card ── */
.device-box {
    background-color: #161b22;
    padding: 18px;
    border-radius: 12px;
    border: 1px solid #30363d;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);
    transition: transform 0.2s ease, border-color 0.2s ease;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    color: #c9d1d9;
}

.device-box:hover {
    transform: translateY(-3px);
    border-color: #58a6ff;
}

/* Card Header (Hostname & IP) */
.dev-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #21262d;
    padding-bottom: 10px;
    margin-bottom: 12px;
}

.dev-hostname {
    font-size: 15px;
    font-weight: 700;
    color: #ffffff;
}

.dev-ip {
    font-size: 12px;
    color: #8b949e;
    font-family: monospace;
}

/* Big Latency / Status Display (PingMon Core Style) */
.dev-latency-display {
    font-size: 18px;
    font-weight: 700;
    color: #58a6ff;
    margin: 10px 0;
}

/* Status Specific Left Border & Background Glow */
.device-box.online {
    border-left: 5px solid #238636;
}

.device-box.offline {
    background-color: rgba(218, 54, 51, 0.08);
    border-left: 5px solid #da3633;
}

.device-box.checking {
    border-left: 5px solid #ffc107;
}

/* Card Footer (Type & Location) */
.dev-card-footer {
    display: flex;
    justify-content: space-between;
    font-size: 11.5px;
    color: #8b949e;
    border-top: 1px solid #21262d;
    padding-top: 10px;
    margin-top: 8px;
}

.dev-card-footer b {
    color: #c9d1d9;
}`, "",{"version":3,"sources":["webpack://./src/components/OverView/OverViewN.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;IACI,aAAa;IACb,4DAA4D;IAC5D,yBAAyB;IACzB,iBAAiB;IACjB,cAAc;AAClB;;AAEA,kDAAkD;AAClD;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,0BAA0B;IAC1B,cAAc;IACd,yCAAyC;IACzC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA,iDAAiD;AACjD,2BAA2B,8BAA8B,EAAE;AAC3D,4BAA4B,8BAA8B,EAAE;AAC5D,6BAA6B,8BAA8B,EAAE;AAC7D,qBAAqB,8BAA8B,EAAE;AACrD,qBAAqB,8BAA8B,EAAE;AACrD,kBAAkB,8BAA8B,EAAE;;AAElD;IACI,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA,gCAAgC;AAChC;IACI,gBAAgB;IAChB,kCAAkC;AACtC;;AAEA;IACI,OAAO,UAAU,EAAE,0BAA0B,EAAE;IAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;AACb;;AAEA,2CAA2C;AAC3C;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,yCAAyC;IACzC,uDAAuD;IACvD,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;IAChC,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,sBAAsB;AAC1B;;AAEA,sDAAsD;AACtD;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA,kDAAkD;AAClD;IACI,8BAA8B;AAClC;;AAEA;IACI,yCAAyC;IACzC,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,cAAc;IACd,6BAA6B;IAC7B,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB","sourcesContent":["/* ── Main Overview Container (Dark NOC Theme) ── */\n.overview-container {\n    padding: 24px;\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\n    background-color: #0b0f19;\n    min-height: 100vh;\n    color: #f8fafc;\n}\n\n/* ── Distinct Styling for H2 and H3 Headings ── */\n.overview-container h2.title {\n    font-size: 28px;\n    font-weight: 800;\n    color: #ffffff;\n    margin-bottom: 4px;\n    letter-spacing: 0.5px;\n    text-align: left;\n    border-bottom: none;\n    padding-bottom: 0;\n}\n\n.overview-container h3.title {\n    font-size: 16px;\n    font-weight: 600;\n    color: #58a6ff;\n    margin-top: 0;\n    margin-bottom: 24px;\n    text-align: left;\n    text-transform: uppercase;\n    letter-spacing: 1.5px;\n    border-bottom: 1px solid #1f2937;\n    padding-bottom: 12px;\n}\n\n/* ── Filter Cards Grid (Top Summary) ── */\n.filter-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n    gap: 15px;\n    margin-bottom: 30px;\n}\n\n.filter-box {\n    background-color: #161b22;\n    padding: 18px;\n    border-radius: 12px;\n    text-align: left;\n    cursor: pointer;\n    border: 1px solid #30363d;\n    transition: all 0.25s ease;\n    color: #c9d1d9;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n    position: relative;\n    overflow: hidden;\n}\n\n.filter-box:hover {\n    transform: translateY(-3px);\n    border-color: #58a6ff;\n    background-color: #1c2128;\n}\n\n.filter-box.selected {\n    border-color: #58a6ff;\n    background-color: #1f2937;\n    box-shadow: 0 0 15px rgba(88, 166, 255, 0.2);\n}\n\n/* Status / Category Accent Borders for Filters */\n.filter-box.totalDevices { border-left: 5px solid #17a2b8; }\n.filter-box.onlineDevices { border-left: 5px solid #238636; }\n.filter-box.offlineDevices { border-left: 5px solid #da3633; }\n.filter-box.switch { border-left: 5px solid #00bcd4; }\n.filter-box.router { border-left: 5px solid #8bc34a; }\n.filter-box.olt { border-left: 5px solid #fd7e14; }\n\n.filter-label {\n    font-weight: 600;\n    font-size: 13px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    color: #8b949e;\n    margin-bottom: 8px;\n}\n\n.filter-count {\n    font-size: 28px;\n    color: #ffffff;\n    font-weight: 700;\n}\n\n/* ── Device Section & Grid ── */\n.device-section {\n    margin-top: 30px;\n    animation: fadeIn 0.3s ease-in-out;\n}\n\n@keyframes fadeIn {\n    from { opacity: 0; transform: translateY(8px); }\n    to { opacity: 1; transform: translateY(0); }\n}\n\n.device-heading {\n    font-size: 20px;\n    margin-bottom: 20px;\n    color: #e6edf3;\n    font-weight: 600;\n}\n\n.device-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n    gap: 18px;\n}\n\n/* ── Modern PingMon Style Device Card ── */\n.device-box {\n    background-color: #161b22;\n    padding: 18px;\n    border-radius: 12px;\n    border: 1px solid #30363d;\n    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.4);\n    transition: transform 0.2s ease, border-color 0.2s ease;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    color: #c9d1d9;\n}\n\n.device-box:hover {\n    transform: translateY(-3px);\n    border-color: #58a6ff;\n}\n\n/* Card Header (Hostname & IP) */\n.dev-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid #21262d;\n    padding-bottom: 10px;\n    margin-bottom: 12px;\n}\n\n.dev-hostname {\n    font-size: 15px;\n    font-weight: 700;\n    color: #ffffff;\n}\n\n.dev-ip {\n    font-size: 12px;\n    color: #8b949e;\n    font-family: monospace;\n}\n\n/* Big Latency / Status Display (PingMon Core Style) */\n.dev-latency-display {\n    font-size: 18px;\n    font-weight: 700;\n    color: #58a6ff;\n    margin: 10px 0;\n}\n\n/* Status Specific Left Border & Background Glow */\n.device-box.online {\n    border-left: 5px solid #238636;\n}\n\n.device-box.offline {\n    background-color: rgba(218, 54, 51, 0.08);\n    border-left: 5px solid #da3633;\n}\n\n.device-box.checking {\n    border-left: 5px solid #ffc107;\n}\n\n/* Card Footer (Type & Location) */\n.dev-card-footer {\n    display: flex;\n    justify-content: space-between;\n    font-size: 11.5px;\n    color: #8b949e;\n    border-top: 1px solid #21262d;\n    padding-top: 10px;\n    margin-top: 8px;\n}\n\n.dev-card-footer b {\n    color: #c9d1d9;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
